import { useSyncExternalStore } from 'react';

import {
  getFruitNinjaRemoteUiSnapshot,
  subscribeFruitNinjaRemoteUi,
} from '../../state/fruitNinjaRemoteUiStore.ts';

function ComboCard({ n, nx, ny }: { n: number; nx: number; ny: number }) {
  return (
    <div
      className="fruit-remote-combo-fx"
      style={{ left: `${nx * 100}%`, top: `${ny * 100}%` }}
      aria-hidden
    >
      <div key={n} className="fruit-remote-combo-fx__card">
        <div className="fruit-remote-combo-fx__line fruit-remote-combo-fx__line--fruit">
          {n} FRUIT
        </div>
        <div className="fruit-remote-combo-fx__line fruit-remote-combo-fx__line--combo">COMBO</div>
        <div className="fruit-remote-combo-fx__bonus">
          <span className="fruit-remote-combo-fx__bonus-plus">+</span>
          {n}
        </div>
      </div>
    </div>
  );
}

/**
 * Крупная всплывашка комбо (как в Fruit Ninja): «N FRUIT» / «COMBO» / «+N», шрифт go3v2.
 * В split-режиме рендерит два независимых комбо — для P1 и P2.
 */
export function FruitNinjaRemoteComboFx() {
  const s = useSyncExternalStore(
    subscribeFruitNinjaRemoteUi,
    getFruitNinjaRemoteUiSnapshot,
    getFruitNinjaRemoteUiSnapshot,
  );

  if (!s.hudVisible) return null;

  const n1 = s.comboCount;
  const n2 = s.combo2Count;

  return (
    <>
      {n1 !== null && n1 >= 1 && (
        <ComboCard n={n1} nx={s.comboNormX ?? 0.78} ny={s.comboNormY ?? 0.36} />
      )}
      {n2 !== null && n2 >= 1 && (
        <ComboCard n={n2} nx={s.combo2NormX ?? 0.22} ny={s.combo2NormY ?? 0.36} />
      )}
    </>
  );
}
